// extracted by mini-css-extract-plugin
export var filterIncDec = "_3z-0";
export var leftBorder = "_3z-1";
export var rightBorder = "_3z-2";
export var stringInput = "_3z-3";